export const FRAMES_FORMATS = ["gif", "mp4", "mp4-browser", "webm", "png"];
